
import axios from "axios";
import Config from "../utils/Config";
import Middleware from "./Middleware";


class RestCalendarService {

    config = {
        headers: {
            Authorization: "",
            CompanyId: "",
        },
    };

    // GET
    setAccessToken(accessToken, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.CompanyId = companyId;
    }

    async getMeetingsByMonth(year, month, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const res = await Middleware.api.get(`/apiVWeb/meeting/byMonth?year=${year}&month=${month}`, this.config);
        return res.data;
    }

    async getMeetingsByDate(date, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const encodedString = encodeURIComponent(date)

        const res = await Middleware.api.get(
            `/apiVWeb/meeting/byDate?date=${encodedString}`,
            this.config
        )
        return res;
    }

    async getMeetingsByDateForCopyForward(date, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const encodedString = encodeURIComponent(date)

        const res = await Middleware.api.get(
            `/apiVWeb/meeting/byDateForCopyForward?date=${encodedString}`,
            this.config
        )
        return res.data;
    }

    async getMeetingsByDateAndId(meetingId, meetingDate, originalDate, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const encodedMeetingDate = encodeURIComponent(meetingDate)
        const encodedOriginalDate = encodeURIComponent(originalDate)

        const res = await Middleware.api.get(
            `/apiVWeb/meeting/byIdAndDate?meetingId=${meetingId}&meetingDate=${encodedMeetingDate}&originalDate=${encodedOriginalDate}`,
            this.config
        )
        return res.data;
    }

    async getMeetingsByIdAndDateForMeetingView(meetingDate, meetingId, originalDate, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const encodedOriginalDate = encodeURIComponent(originalDate)

        const res = await Middleware.api.get(`/apiVWeb/meeting/byIdAndDateForMeetingView?meetingDate=${meetingDate}&meetingId=${meetingId}&originalDate=${encodedOriginalDate}`, 
            this.config
        );
        return res.data;
    }

    async getMeetingsByIdAndDateForMeetingUpdate(meetingDate, meetingId, originalDate, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const encodedOriginalDate = encodeURIComponent(originalDate)

        const res = await Middleware.api.get(
            `/apiVWeb/meeting/byIdAndDateForMeetingUpdate?meetingDate=${meetingDate}&meetingId=${meetingId}&originalDate=${encodedOriginalDate}`,
            this.config
        )
        return res.data;
    }

    async getMeetingsByIdAndDateForAgendaUpdate(meetingDate, meetingId, originalDate, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const encodedOriginalDate = encodeURIComponent(originalDate)

        const res = await Middleware.api.get(
            `/apiVWeb/meeting/byIdAndDateForAgendaUpdate?meetingDate=${meetingDate}&meetingId=${meetingId}&originalDate=${encodedOriginalDate}`,
            this.config
        )
        return res.data;
    }
    
    async getMeetingsByDatePeriod(startDate, endDate, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const encodedstartingDate = encodeURIComponent(startDate)
        const encodedEndingDate = encodeURIComponent(endDate)

        const res = await Middleware.api.get(
            `/apiVWeb/meeting/byDatePeriod?startDate=${encodedstartingDate}&endDate=${encodedEndingDate}`,
            this.config
        )
        return res.data;
    }
}

export default new RestCalendarService();
